export function isSeasonRegistrationOpen(season) {
  return Boolean(season && season.registrationOpen === true);
}
